import { Compound } from './compound';
import { DiscriminatedUnion } from './discriminatedUnion/discriminatedUnion';
import { SchemaFormFields as Fields, SingleField } from './schemaForm';

export type { DiscriminatedUnionFormDefinition } from './discriminatedUnion/discriminatedUnion';
export type { SchemaFormDefinition } from './schemaForm';

export const SchemaFormFields = Object.assign(Fields, {
    Field: SingleField,
    DiscriminatedUnion,
    Compound,
});
